/**
 * Module definition for login module. The login module manages
 * the application's top-level login view (i.e., /login).
 *
 * @module routes.login
 */

angular.module('routes.login', [
  'stack',
  'routes.login.constants',
  'routes.login.LoginController'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.login', {
          url: '/login',
          templateUrl: 'routes/login/login.html',
          controller: 'LoginController',
          params: {},
          resolve: {
            constants: ['ConstantResolver', 'LOGIN', function (ConstantResolver, LOGIN) {
              return new ConstantResolver(LOGIN);
            }]
          }
        }
      );
    }
  ]
);
